import React, { useState } from 'react';
import "../CSS/SoftWares.css";
import spic1 from "../Images/spic1.png"
import spic2 from "../Images/spic2.png"

import video1 from "../videos/Flood Simulation On Gully Site @ IMO STATE of Nigeria.mp4"
import video2 from "../videos/Lagos Train Station Overview WITH INFRAWORKS TOOLS.mp4"

const softwareData = [
  { id: 1, image: spic1, url:"https://www.youtube.com/watch?v=N4AR1d8iw8g&feature=youtu.be", title: "ARCGIS SUITS", description1: "Flood Simulation On Gully Site @ IMO STATE", description2: "Used for studying the earth surface behaviour, perform spatial analysis of digital elevation model, (DEM) of project sites, such as natural drainage path of the earth surface, flood simulation analysis, watershed analysis, determine quantity of run off.",mediaDescription:"Flood simulation performed on a gully site,a NEWMAP RESEARCH",media:video1 },
  { id: 2, image: spic2, url:"https://www.youtube.com/watch?v=W1W-Y9Dv6TU", title: "AUTODESK INFRAWORKS", description1: "Lagos City Train Station Overview", description2: "This is a 3d software used for situating all kind of City features (city road network, railways, infrastructure, water ways, building zones, etc), as it relates to the real world. This is employed in order to optimize the operational and the functionality of the project deliverable during planning stage.", mediaDescription:"A pilot Project for Lagos State Redevelopment",media:video2},
  
];



const SoftWares = () => {
    const [expandedCard, setExpandedCard] = useState(null);
  
    const toggleExpand = (id) => {
      setExpandedCard(expandedCard === id ? null : id);
    };
  
    return (
      <div className='SoftwareContainerWrap' id="projects">
        <h1>SOME OF THE APPS I DEPLOYED ON SOME PROJECTS</h1>
       <div className="software-container">
        {softwareData.map((software) => (
          <div className="software-card" key={software.id}>
            <img src={software.image} alt={software.title} className="software-image" />
            <p style={{color:"rgba(0,0,255,0.7)",fontStyle:"italic",fontWeight:"500"}}>{software.description1}</p>
            <h3 style={{color:"blue"}}>{software.title}</h3>
            <p className="expanded">
              {software.description2}
              {/* {expandedCard !== software.id && <span className="ellipsis">...</span>} */}
            </p>
           
            <video controls loop className='video'>
              <source src={software.media} type='video/mp4'/>
            </video>
            <p style={{fontWeight:"bold",color:"rgba(0,0,255,0.7)"}}>{software.mediaDescription}</p>
            {/* <button onClick={() => toggleExpand(software.id)}>
              {expandedCard === software.id ? "Show Less" : "Show More"}
            </button> */}
            {/* <button onClick={() =>window.open(`${software.url}`,"_blank")}>
              Watch
            </button> */}
          </div>
        ))}
      </div> 
      </div>
    );
  };
  
  export default SoftWares;